<app-dialog-header (backClick)="onNoClick()" [header]="getHeader()"></app-dialog-header>

<div class="dialog-view-wrapper">
  @if (data.xpac.ccap) {
    <xpac-ccap-general-info [ccap]="data.xpac"></xpac-ccap-general-info>
  }
  @else {
  <mat-tab-group mat-stretch-tabs>
    <mat-tab label="{{ 'Modules.RemoteMaintenanceItemInfoComponent.List.General.TabHeader' | translate }}">
      <ng-template matTabContent>
        <xpac-remote-maintenance-item-general [xpac]="data.xpac"></xpac-remote-maintenance-item-general>
      </ng-template>
    </mat-tab>
    <mat-tab label="{{ 'Modules.RemoteMaintenanceItemInfoComponent.List.Connections.TabHeader' | translate }}">
      <ng-template matTabContent>
        <xpac-last-connections [xpac]="data.xpac"></xpac-last-connections>
      </ng-template>
    </mat-tab>
    <mat-tab *ngIf="('devices' | hasPermission :'Device_Replace':'action' | async)"
      label="{{ 'Modules.RemoteMaintenanceItemInfoComponent.List.Replacement.TabHeader' | translate }}">
      <ng-template matTabContent>
        <xpac-xpac-replacement [xpac]="data.xpac"></xpac-xpac-replacement>
      </ng-template>
    </mat-tab>
    <mat-tab *ngIf="('devices' | hasPermission :'Device_RemoteMaintenanceConnections':'read' | async)"
      label="{{ 'Modules.RemoteMaintenanceItemInfoComponent.List.RemoteConnections.TabHeader' | translate }}">
      <ng-template matTabContent>
        <xpac-service-connections [xpac]="data.xpac"></xpac-service-connections>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
  }
</div>
